import { Toast } from 'modules/Core/Common/Toast';

const defaultErrorToast = (defaultMessage) => (error) => {
  const { message = '' } = error || {};
  Toast(message || defaultMessage, 'error');
};

export { defaultErrorToast };
